import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { Loading } from '../common/LoadingComponent';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';
import {
    Search, Package, Route, MapPin, Flag,
    Plane, Car, Train, Bus, ArrowDown,
} from '../../icons';

const TRANSPORT_ICONS = { Avion: Plane, Voiture: Car, Train: Train, Bus: Bus };

function getTransportIcon(means) {
    return TRANSPORT_ICONS[means] || Package;
}

function parseCities(raw) {
    if (!raw) return [];
    return raw.split('--').filter(Boolean);
}

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} role="tabpanel">
            {value === index && <Box pt={1}>{children}</Box>}
        </div>
    );
}
TabPanel.propTypes = { children: PropTypes.node, index: PropTypes.any.isRequired, value: PropTypes.any.isRequired };

function a11yProps(index) {
    return { id: `tab-${index}`, 'aria-controls': `tabpanel-${index}` };
}

const RenderAnnouncementItem = ({ announcement, user }) => {
    const departureCities = parseCities(announcement.departure);
    const destCities      = parseCities(announcement.destination);
    const isTrip          = !!announcement.dateDestination;
    const TransIcon       = getTransportIcon(announcement.meansOfTransport);
    const dateStr         = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: '2-digit', month: 'short' })
        .format(announcement.dateDeparture);

    return (
        <Link
            to={{ pathname: `/announcements/${announcement.id}`, state: { from: window.location.pathname } }}
            className="result-card"
        >
            <div className="result-card__inner">
                <div className="result-card__top">
                    <div className="result-card__date">
                        <TransIcon size={14} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 5 }} />
                        {dateStr}
                    </div>
                    <span className="result-card__price">{announcement.price} €</span>
                </div>
                <div className="result-card__route">
                    <div className="result-card__city">
                        <MapPin size={14} strokeWidth={2} color="var(--primary)" style={{ verticalAlign: 'middle', marginRight: 6, flexShrink: 0 }} />
                        {departureCities[0] || '—'}
                    </div>
                    {destCities.slice(0, destCities.length - 1).map((city, i) => (
                        <div key={i} className="result-card__arrow">
                            <ArrowDown size={13} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 6 }} />
                            <span style={{ color: 'var(--gray)', fontSize: '0.88rem' }}>{city}</span>
                        </div>
                    ))}
                    <div className="result-card__city mt-1">
                        <Flag size={14} strokeWidth={2} color="var(--gray)" style={{ verticalAlign: 'middle', marginRight: 6, flexShrink: 0 }} />
                        {destCities[destCities.length - 1] || '—'}
                    </div>
                </div>
                <div className="result-card__footer">
                    <img className="result-card__avatar" src="/assets/images/profil.svg" alt="avatar" />
                    <span className="result-card__user">{user.firstName} {user.lastName}</span>
                    <span className={`result-card__badge ${isTrip ? 'result-card__badge--trip' : 'result-card__badge--delivery'}`}>
                        {isTrip ? 'Trajet' : 'Envoi'}
                    </span>
                </div>
            </div>
        </Link>
    );
};

class Announcements extends Component {
    constructor(props) {
        super(props);
        this.state = { value: 0 };
    }

    handleChange = (event, newValue) => this.setState({ value: newValue });

    render() {
        const { announcementsWithUser } = this.props;

        if (announcementsWithUser.isSearchAnnouncements) {
            return <div className="container text-center" style={{ padding: '80px 0' }}><Loading /></div>;
        }

        if (announcementsWithUser.errMess) {
            return <div className="container text-center" style={{ padding: '80px 0' }}><h4 style={{ color: 'var(--gray)' }}>{announcementsWithUser.errMess}</h4></div>;
        }

        const list = announcementsWithUser.responseSearchAnnouncements || [];

        if (!list.length) {
            return (
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-6">
                            <div className="empty-state">
                                <div className="empty-state__icon"><Search size={48} strokeWidth={1.2} color="var(--border)" /></div>
                                <h3 className="empty-state__title">Aucun résultat pour ce trajet</h3>
                                <p className="empty-state__text">Il n'existe pas encore de trajet ou de demande d'envoi entre ces deux villes. Soyez le premier !</p>
                                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                                    <Link to="/adddelivery"><Button color="primary" style={{ borderRadius: 50, padding: '12px 24px', fontWeight: 700 }}>Envoyer un colis</Button></Link>
                                    <Link to="/addtrip"><Button outline color="primary" style={{ borderRadius: 50, padding: '12px 24px', fontWeight: 700 }}>Proposer un trajet</Button></Link>
                                </div>
                                <div className="mt-3"><Link to="/searchannouncements" className="auth-link">Nouvelle recherche</Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const all        = list.map(a => <RenderAnnouncementItem key={a.announcement.id} announcement={a.announcement} user={a.user} />);
        const trips      = list.filter(a => a.announcement.dateDestination != null).map(a => <RenderAnnouncementItem key={a.announcement.id} announcement={a.announcement} user={a.user} />);
        const deliveries = list.filter(a => a.announcement.dateDestination == null).map(a => <RenderAnnouncementItem key={a.announcement.id} announcement={a.announcement} user={a.user} />);

        const tabStyle = { fontSize: '0.88rem', fontWeight: 700, textTransform: 'none', minWidth: 80 };

        return (
            <div style={{ background: 'var(--bg-light)', minHeight: '100vh', paddingBottom: 80 }}>
                <div className="container" style={{ paddingTop: 24 }}>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: 'var(--dark)', margin: 0 }}>
                                    {list.length} résultat{list.length > 1 ? 's' : ''}
                                </h2>
                                <Link to="/searchannouncements">
                                    <Button outline color="primary" size="sm" style={{ borderRadius: 50, fontWeight: 700, padding: '6px 16px', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        <Search size={14} strokeWidth={2.5} /> Modifier
                                    </Button>
                                </Link>
                            </div>
                            <AppBar position="static" style={{ background: 'transparent', boxShadow: 'none', marginBottom: 12 }}>
                                <Tabs value={this.state.value} onChange={this.handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
                                    <Tab label={`Tout (${all.length})`}        style={tabStyle} {...a11yProps(0)} />
                                    <Tab label={`Envois (${deliveries.length})`} style={tabStyle} {...a11yProps(1)} />
                                    <Tab label={`Trajets (${trips.length})`}   style={tabStyle} {...a11yProps(2)} />
                                </Tabs>
                            </AppBar>
                            <TabPanel value={this.state.value} index={0}>{all}</TabPanel>
                            <TabPanel value={this.state.value} index={1}>
                                {deliveries.length ? deliveries : (
                                    <div className="empty-state">
                                        <Package size={40} strokeWidth={1.2} color="var(--border)" />
                                        <p className="empty-state__text" style={{ marginTop: 16 }}>Aucune demande d'envoi pour ce trajet.</p>
                                        <Link to="/adddelivery"><Button color="primary" style={{ borderRadius: 50, fontWeight: 700 }}>Publier un envoi</Button></Link>
                                    </div>
                                )}
                            </TabPanel>
                            <TabPanel value={this.state.value} index={2}>
                                {trips.length ? trips : (
                                    <div className="empty-state">
                                        <Route size={40} strokeWidth={1.2} color="var(--border)" />
                                        <p className="empty-state__text" style={{ marginTop: 16 }}>Aucun trajet disponible pour cette route.</p>
                                        <Link to="/addtrip"><Button color="primary" style={{ borderRadius: 50, fontWeight: 700 }}>Proposer un trajet</Button></Link>
                                    </div>
                                )}
                            </TabPanel>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Announcements;
